import type { FaireProductEntity } from "../../entity_types/product";

export const p_mswsmgkx5x: FaireProductEntity = {
  token: "p_mswsmgkx5x",
  type: "product",
  name: "Hand-painted Heart Amazing Hair Day Brush | Eco-Friendly",
  brandToken: "b_z4cmjuda3k",
  brandName: "Solar Eclipse",
  imageUrl:
    "https://cdn.faire.com/fastly/3d1cec688992b8fb08e83030c736c82952cb4b3cd14c160f15cab80481fa955d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/30e97cad2e2d794115e558c3a00a87aadace3d52efd9c2d820829b8334527165.jpeg",
    "https://cdn.faire.com/fastly/0ff93b8187ee8ef205f2dc695cdab0d464ffce2359b3986cd496723d6579e7c2.jpeg",
  ],
  priceDollars: 39.72,
  description:
    "PREORDER\n\nHand-painted by our Solar Eclipse artists, our hair brush is crafted in small batches. It's designed to upgrade your routine and be treasured for years to come.\n\nDesigned in New York City, our two-in-one brush is created to be the perfect daily brush to optimize hair health and aid easy, fast styling for all hair types and textures.\n\nFeaturing two types of bristles, it can be safely used on wet and dry hair to gently detangle without causing breakage, smooth and style, promote hair growth and increase circulation. \n\nHandmade with the finest eco-friendly, vegan materials, it’s your secret weapon to make every day an amazing hair day. \n\n\n\n\nKey Features\n\nVegan boar-like bristles: Stimulate natural hair growth, evenly distribute natural oils and smooth hair.\n\nDetangling bristles: Safely detangle wet hair and massage scalp.\n\nHand-painted: Each brush is carefully hand-painted by our Solar Eclipse artists.\n\nOriginal Design: Copyright original design you won't find anywhere else!\n\nCellulose Acetate: Crafted from a eco-friendly, biodegradable material made from recycled wood pulp.\n\nSustainable Packaging: 100% recyclable & plastic-free packaging.\n\n\n\n\nWe are very proud of our original art. Our copyright designs are protected internationally by intellectual property law.\n\nAll brushes are final sale and are not eligible for return or refund for hygiene reasons.\n",
  tags: [],
  msrpDollars: 79.44,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:47.045Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
